export default __webpack_public_path__ + "static/media/008-level crossing.053e35fb.png";